import React, {useState, useEffect} from 'react';
import Loader from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import * as masterProcessActions from '../../Redux/Actions/masterProcess';
import {toastMessage} from '../../utils/toast';
import { useDispatch } from 'react-redux';
import { clearSession } from '../../utils/initiate';
import Warning from '../Ui/400';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const Sort = ({match, history}) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errStatus, setErrStatus] = useState(200);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        setLoading(true);
        masterProcessActions.getAll().then((res) => {
            if(res?.data) {
                setData(res.data);
            }
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            setErrStatus(err.response?.status);
            (err.response?.status === 401) && clearSession(dispatch, history);
        })
    }, []);

    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        result.filter(res => res !== null);
        return result;
    };

    const onDragEnd = (result) => {
        if(!result.destination) return;
       
        const tempData = reorder(data, result.source.index, result.destination.index);
        setData(tempData);
        console.log(tempData);
        const payload = tempData.map(({id}, index) => {
            index++;
            return {...{index, id}}
        });
        console.log(payload);
    }

    if(errStatus === 400){
        return <Warning history={history} />
    }

    return(
        <>
            <div className="container-fluid">
                <div className="page-title-box">
                    <h4 className="page-title my-2">{"Master Process"}</h4>
                </div>
                <div className="row">
                    <div className="col-lg-12 col-xxl-12">
                        <div className="card card-custom card-stretch gutter-b">
                            {loading ? <Loader type="ThreeDots" color="#ad1a5f" height={40} width={40} style={{textAlign: 'center', marginBottom: '50px'}} />
                            : <div className="card-body py-3">
                                <div className="tab-content">
                                    <div className="table-responsive">
                                        <table className="table table-head-custom table-vertical-center table-head-bg">
                                            <thead>
                                                <tr className="text-left">
                                                    <th style={{minWidth: '60px'}} className="ps-5"><span className="text-dark-75">{t("mastersManagement.manage.id")}</span></th>
                                                    <th style={{minWidth: '80px'}}><span className="text-dark-75">{t("mastersManagement.manage.name")}</span></th>
                                                    <th style={{minWidth: '100px'}}><span className="text-dark-75">{t("mastersManagement.manage.department")}</span></th>
                                                </tr>
                                            </thead>
                                            <DragDropContext onDragEnd={onDragEnd}>
                                                <Droppable droppableId="droppable">
                                                    {(provided) => (
                                                        <tbody {...provided.droppableProps} ref={provided.innerRef}>
                                                            {data?.map(({id, name, department}, index) => (
                                                                <Draggable draggableId={""+id} key={id} index={index}>
                                                                    {(provided) => (
                                                                        <tr ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                                            <td className="ps-5">
                                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{id}</span>
                                                                            </td>
                                                                            <td className="pl-0 py-8">
                                                                                <span className="text-dark-75 font-weight-bolder text-hover-primary d-block font-size-lg">{name}</span>
                                                                            </td>
                                                                            <td className="pl-0 py-8">
                                                                                <span className="text-dark-75 font-weight-bolder text-hover-primary d-block font-size-lg">{department.name}</span>
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                </Draggable>
                                                           ))}
                                                           {provided.placeholder}
                                                        </tbody>
                                                    )}
                                                </Droppable>
                                            </DragDropContext>
                                        </table>
                                    </div>
                                </div>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Sort;